import React, { Component } from 'react'
import Web3 from 'web3';
import FreeToken from './FreeToken'


import './css.css';


class FreebiesList1_0 extends Component {
 constructor(props){
     super()
     this.state={
         edit:true,
         items:[],
         box:"",
         boxindex:0,
         ticket:"",
         focus:"",
         loading:true
        }
 }

    componentDidMount() {
        this.loadItems()
        
    }




    async setAmount(){
        let addr=this.props.address
        await window.ethereum.enable().then(await async function (accounts) { 
            const { REACT_APP_FREEBIES1_0ABI } = process.env;
            const { REACT_APP_PriceListABI } = process.env;
            const priceListC = new web3.eth.Contract(JSON.parse(REACT_APP_FREEBIES1_0ABI), addr) 
                let priceListz = await priceListC.methods.prices().call()
                console.log("priceListz",priceListz)
                const prices = new web3.eth.Contract(JSON.parse(REACT_APP_PriceListABI), priceListz) 
            if(document.getElementById("Shop_add_item_setamount_field").value!=""){
            if(parseFloat(document.getElementById("Shop_add_item_setamount_field").value)>0){
            await prices.methods.setPrice(document.getElementById("Shop_add_item_setaddress_field").value,parseInt(parseFloat(document.getElementById("Shop_add_item_setamount_field").value)*1000)).send({from: accounts[0] , gas: 323456 })
            }else{
                alert("SET AN AMOUNT > 0")
            }    
        }else{
                alert("SET A TOKEN ADDRESS IN ORDER TO ADD A FREEBIE TO THE SHOP!")
            }
         
        })
        this.loadItems()
        
    }



    async loadItems() {
      
        let total_listing=[]

        let addr=this.props.address
        let priceListz
        let box
        await window.ethereum.enable().then(async function (accounts) {
            let account=accounts[0];
            try{
                const { REACT_APP_FREEBIES1_0ABI } = process.env;
                const { REACT_APP_PriceListABI } = process.env;
            const tick = new web3.eth.Contract(JSON.parse(REACT_APP_FREEBIES1_0ABI), addr) 
            priceListz = await tick.methods.prices().call()
            console.log("priceListz",priceListz)
            box = await tick.methods.box().call()
            console.log("BOX",box)
            const prices = new web3.eth.Contract(JSON.parse(REACT_APP_PriceListABI), priceListz) 
            let index = await prices.methods.priceListing(0).call()
            console.log("index",index)
            for(let i=0;i<parseInt(index[2]);i++){
                let item = await prices.methods.priceListing(i).call()
                console.log("tkn",item[0])
                try{
                    const { REACT_APP_ABI } = process.env;
                 
               
                const tkn = new web3.eth.Contract(JSON.parse(REACT_APP_ABI), item[0]) 
                
                let name = await tkn.methods.totalSupply().call()
                console.log("tkn",name)
                let a=[]
                a.push(item)
                a.push(name)
                total_listing.push(a)
                }catch(e){}
               
            }
            console.log("LOADED ITEMS "+total_listing)
            
        }catch(e){console.log("FreebiesList loadItems()",e)}
        })

        this.setState({items : total_listing,priceList : priceListz,focus : addr,box : addr,loading:false})
        try{this.props.setAmount(total_listing.length)}catch(e){}
        //this.render()
        
            
        }


         editMode(){
           // alert("STATE: "+this.state.edit)
            (!this.state.edit)?this.setState({edit:true}):this.setState({edit:false})
        }

    render(){
const final = [];
let n=this.props.index;
console.log("FREEBIESLIST PROPS",this.props.edit)
if(this.props.address!=this.state.focus)this.loadItems()
  for (let  itm of this.state.items) {  
    final.push(<FreeToken  db={this.props.db} priceList={this.state.priceList} address={itm[0][0]} price={itm[0][1]} index={this.props.address+"x"+n++} key={n++} edit={this.props.edit} name={itm[1]} ticket={this.props.address}></FreeToken>);
  }
        return ( 
        
            
                
                <div className="Shop_module_main">
                  {
                (this.state.loading)?<center><img className="loadergif" id="pricelist_loadergif" src="https://androidexample365.com/content/images/2019/07/rainbow_ring.gif"></img></center>:<></>
                }
                {(final.length>0)?
                <div>
                
                <div className="Shop_module_item_row">
                    <div className="Shop_module_link_panel">
                    {(!getUrlVars()["shop"])?<span className="Price_list_label" onClick={() => window.open("https://ropsten.etherscan.io/address/"+this.state.focus)}>🎀 #{this.props.index}</span>:<span className="Price_list_label"><a  className="Freebieslist_link" href={"https://ropsten.etherscan.io/address/"+this.state.focus} target="_blank">🎀</a></span>}
                    {(!getUrlVars()["shop"])?<span className="Shop_module_link_icon right" onClick={() => jump(this.state.focus)}>🛒</span>:<></>}
                            <span className="Shop_module_link_icon right" onClick={() => jumpBox(this.state.box)}>📦</span>
                     </div>       
                </div>
                {final}
                </div>
                :
                <>
                {(this.props.edit)?<div className="empty_message">#{this.props.index} give away something!</div>:<></>}
                {(this.props.edit)?
                <div className="Shop_add_item_row">
                    <div className="Shop_module_link_panel">
                    {(!getUrlVars()["shop"])?<span className="Price_list_label" onClick={() => window.open("https://ropsten.etherscan.io/address/"+this.state.focus)}>🎀 #{this.props.index}</span>:<span className="Price_list_label"><a className="Freebieslist_link" href={"https://ropsten.etherscan.io/address/"+this.state.focus} target="_blank">🎀</a></span>}
                    {(!getUrlVars()["shop"])?<span className="Shop_module_link_icon right" onClick={() => jump(this.state.focus)}>🛒</span>:<></>}
                            <span className="Shop_module_link_icon right" onClick={() => jumpBox(this.state.box)}>📦</span>
                     </div>       
                </div>:
                <></>}
                </>
                }
                {(this.props.edit)?
                <div>
                <div className="Shop_add_item_row">
                    <div className="Shop_add_item_panel">
                            <img id="Shop_add_item_icon" src="https://i.imgur.com/YKhumij.png"></img>
                            <div className="Shop_item_setprice">
                                <input id="Shop_add_item_setaddress_field" className="Shop_item_setprice_field" type="text"></input>
                                <span className="right paddingright">address</span>
                            </div>
                            <div className="Shop_item_setprice">
                                <input id="Shop_add_item_setamount_field" className="Shop_add_item_setamount_field" type="text"></input>
                                <input className="Shop_item_setprice_button" type="button" value="✒️ Set Amount" onClick={() => this.setAmount()}></input>
                            </div>
                    </div>
                </div>
                </div>:
                    <div></div>
                    }
        </div>
        );
    }


}

function jumpBox(addr){
    window.open('https://ropsten.etherscan.io/address/'+addr)
}

function jump(addr){
    window.open('?shop='+addr)
}

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}


const web3 = new Web3(Web3.givenProvider || "http://localhost:8545")

export default FreebiesList1_0